import $ from 'jquery'
import deferAction from 'scripts/utils/deferAction';

const inputSearch = () =>{
  const keyUpFilter = () =>{
    const input = $('.js-search');

    input.on('keyup', function keyUp(event){
      const $this = $(this);
      const value = $this.val().toLowerCase();
      let searchList;
      let length = 1;

      deferAction(()=>{
        if($this.siblings('select').length){
          searchList = $this.parents('.search-label').find('.select__list');

          length = 2;
        }else{
          searchList = $this.parents('.search-label').find('.search-dropdown')
        }
        
        const listItems = searchList.find('li:not(.not-found)');

        if(value.length >= length && value !== ''){
          if(!$this.parents('.search-change').length ){
            searchList.addClass('active');
          }
          listItems.show();

          listItems.each((key, item) => {
            const text = $(item).text().toLowerCase().trim();
            const replaceSymbols = value.replace(/([.?*+^$[\]\\(){}|-])/g, "");

            if ($this.hasClass('js-search-stores')) {
              if(text.search(replaceSymbols) === 0){
                $(item).show();
              }else{
                $(item).hide();
              }
            } else {
              if(text.search(replaceSymbols) !== -1){
                $(item).show();
              }else{
                $(item).hide();
              }
            }
          });
        }else{
          listItems.show();

          if(!$this.parents('.search-change').length ){
            searchList.removeClass('active');
            $this.parents('.checkout-city').removeClass('active');
          }
          
        }

        if(event.code === 'Enter' && $this.parents('.block-stores__form').length){
          event.stopPropagation(event);
          
          if(value.trim() !== ''){
            const foundedList = $this.siblings('.search-dropdown').find('li:visible:not(.not-found)');

            foundedList.each((key, item)=>{
              const link = $(item).find('a');
              const linkText = link.text().toLocaleLowerCase();


              if(linkText === value || (foundedList.length === 1 && linkText.search(value) !== -1) ){
                window.location = link.attr('href');
              }else{
                foundedList.hide();
              }

            })
          }
          
        }
      });
    });

    $(".block-stores__form").submit(e => {
      e.preventDefault(e)
    });

    $(document).on('focus','.search-change .js-search', function setActiveClass(){
      const $this = $(this);
      const list = $this.parents('.search-change').find('.select__list');

      list.addClass('active');
    }).on('click','.search-change .select__item', function getSelectedText(){
      const $this = $(this);
      const text = $this.text();
      const value = $this.attr('data-value');
      const field = $this.parents('.search-change').find('.js-search');

      field.val(text).attr('value',' ').attr('data-value',value);
      $this.parents('.select__list').removeClass('active');
    });
  }

  $(document).mouseup(e => {
    const searchMenu = $(".search-label");
    if (!searchMenu.is(e.target) && searchMenu.has(e.target).length === 0) {
      $('.search-dropdown,.search-label .select__list').removeClass('active');
      $('.checkout-city').removeClass('active');
    }
  });

  keyUpFilter();
}

export default inputSearch;